import {Food} from "./types";

const Fish: Food = {
    "Lemon Herb Salmon": {
        "Lemon Herb Salmon": "4.5oz",
        "Jasmine Rice": "4.5oz (GREY scoop)",
        "Boiled Green Beans": "2.5oz",
        "Garnish": "Parsley and Lemon Wheel"
    },
    "Blackened Shrimp Pasta": {
        "Blackened Shrimp": "6 pieces",
        "Pasta Salad": "6oz",
        "Zucchini": "5 slices",
        "Cherry Tomatoes": "4 pieces"
    },
    "Blackened Salmon": {
        "Blackened Salmon": "4.5oz",
        "Yellow Rice": "4.5oz (TIGHT GREY scoop)",
        "Fajita Veg": "2.5oz"
    }
}

export default Fish